import $ from 'jquery'
import { isShow } from '../_variables'

export default class AccdPremior {
  init() {
    $(function () {
      $('.js-accd-premior').on('click', function () {
        if (!$(this).hasClass(isShow)) {
          $(this).addClass(isShow).text('閉じる')
          $('.box-accd-detail').stop().slideDown()
        } else {
          $(this).removeClass(isShow).text('主な成分を見る')
          $('.box-accd-detail').stop().slideUp()
        }
      })
      $('.js-accd-premior').trigger('click')
    })
  }
}
